import type { ReactNode } from 'react';
import React from 'react';

import type { PageBlockContextShape } from './PageBlockContext';
import { PageBlockContext } from './PageBlockContext';

type PageBlockProviderProps = {
  children: ReactNode;
  size: PageBlockContextShape['size'];
};

export const PageBlockProvider = ({
  children,
  size,
}: PageBlockProviderProps) => {
  return (
    <PageBlockContext.Provider value={{ size }}>
      {children}
    </PageBlockContext.Provider>
  );
};
